import { Component, OnInit, ElementRef, ViewChild, AfterViewInit, Renderer, OnDestroy } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { BackendService } from 'src/app/services/backend.service';
import { Router, NavigationEnd } from '@angular/router';
import * as jsPDF from 'jspdf';
import * as html2canvas from 'html2canvas';
import { AngularWaitBarrier } from 'blocking-proxy/built/lib/angular_wait_barrier';
import { Script } from 'vm';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import {forkJoin} from 'rxjs';


@Component({
  selector: 'app-pdfmmse',
  templateUrl: './pdfmmse.component.html',
  styleUrls: ['./pdfmmse.component.scss']
})
export class PdfmmseComponent implements OnInit, OnDestroy {


  constructor(private translate: TranslateService, private backendService: BackendService, private router: Router, private renderer: Renderer) {
  this.translate.addLangs(['es', 'pt']);
  this.smartBMedida = [];
  this.smartBFecha = [];
  this.chartData = [];
  this.chartLabels = [];

  this.section3 = {};
  this.section1 = {};
  this.section2 = {};
  this.section4 = {};
  this.ciudadano = {};


  this.router.events.subscribe(val => {
      if (
          val instanceof NavigationEnd &&
          window.innerWidth <= 992 &&
          this.isToggled()
      ) {
          this.toggleSidebar();
      }
  });
}
  error = false;
  showHistorial: Boolean = false;
  showDelete: Boolean = false;
  errorMessage: String = '';
  dataLoading = false;
  private querySubscription;
  savedChanges = false;
  public pushRightClass: string;
  ciudadano;
  id_section1;
  id_paciente;
  si = false;
  smartBand; smartBMedida; smartBFecha; chartData; chartLabels;
  citizen1; citizen2; citizen3; citizen4; citizen5; citizen6; citizen7; citizen8; citizen9; citizen10;
  valor;

  section3;
  section1;
  section2;
  section4;
  titulo = 'Generar PDF con Angular JS 5';
  pdfSrc = '/pdf-test.pdf';


  ENCS_general_value = 0;
  ENCS_autocuidado_value = 0;
  ENCS_aprendizaje_value = 0;
  ENCS_comunicacao_value = 0;
  ENCS_ambiente_value = 0;




  isToggled(): boolean {
    const dom: Element = document.querySelector('body');
    return dom.classList.contains(this.pushRightClass);
  }

  changeLang(language: string) {
    this.translate.use(language);
  }

  showHisto() {
    this.showHistorial = true;

  }

  toggleSidebar() {
    const dom: any = document.querySelector('body');
    dom.classList.toggle(this.pushRightClass);
  }

  ngOnInit() {
    this.id_section1 = window.localStorage.getItem('idENCS');
    this.id_paciente = window.localStorage.getItem('idPaciente');
    const data = JSON.parse(window.localStorage.getItem('MIAPePDFdata'));

    console.log(data);
    if (localStorage.length <= 0) {
      this.router.navigate(['../login']);
    } else {
        if (localStorage.getItem('token') == null) {
            this.router.navigate(['../login']);
        } else {

          const observables: Observable<any>[] = [];

          /*this.getCitizenById(this.id_paciente);
          this.getSection1();
          this.getSection2();
          this.getSection3();
          this.getSection4();*/

          this.getCitizen(data);
          this.getSection1(data);
          this.getSection2(data);
          this.getSection3(data);
          this.getSection4(data);

          this.computeValuesENCS();
          this.sleep(1000).then(() => {
            this.imprimir();
        });
        }
    }
  }



  getCitizen(data) {
    this.ciudadano = data['ciudadano'];
  }
  getSection1(data) {
    this.section1 = data['section1'];
  }
  getSection2(data) {
    this.section2 = data['section2'];
  }
  getSection3(data) {
    this.section3 = data['section3'];
  }
  getSection4(data) {
    this.section4 = data['section4'];
  }


  computeValuesENCS() {

    this.ENCS_autocuidado_value = (this.section3.q12 + this.section3.q16 + this.section3.q17 + this.section3.q18 + this.section3.q19 + this.section3.q20 + this.section3.q21 + this.section3.q22 + this.section3.q23 + this.section3.q24 + this.section3.q25 + this.section3.q26) / 12;
    this.ENCS_aprendizaje_value = (this.section2.q1 + this.section2.q2 + this.section2.q3 + this.section2.q4 + this.section2.q5 + this.section2.q6) / 6;
    this.ENCS_comunicacao_value = (this.section3.q13 + this.section3.q14 + this.section3.q15) / 3;
    this.ENCS_ambiente_value = (this.section3.q27 + this.section4.q29 + this.section4.q30 + this.section4.q31) / 4;
    this.ENCS_general_value = (this.ENCS_autocuidado_value + this.ENCS_aprendizaje_value + this.ENCS_comunicacao_value + this.ENCS_ambiente_value) / 4;

    console.log(this.ENCS_autocuidado_value);
    console.log(this.ENCS_aprendizaje_value);
    console.log(this.ENCS_comunicacao_value);
    console.log(this.ENCS_ambiente_value);
    console.log(this.ENCS_general_value);

  }

  getTargetForHistorialValue(value) {
    if (1 <= value && value <= 1.6) {
      return 'ENCSTargetForHistorialValue1';
    }
    if (1.6 < value && value <= 1.96) {
      return 'ENCSTargetForHistorialValue2';
    }
    if (1.96 < value && value <= 2.96) {
      return 'ENCSTargetForHistorialValue3';
    }
    if (2.96 < value && value <= 4.84) {
      return 'ENCSTargetForHistorialValue4';
    }
    if (4.84 < value && value <= 5) {
      return 'ENCSTargetForHistorialValue5';
    }
    return value;
  }

 /*  getSmartBand(){
    this.dataLoading = true;
    this.querySubscription = this.backendService.getSmartBand().subscribe((res) => {
        if (res["errorCode"] > 0) {
            this.error = false;
            this.errorMessage = "";
            this.dataLoading = false;
            this.smartBand = res["data"];
            this.smartBFecha[this.smartBand.length];
            this.smartBMedida[this.smartBand.length];
          } else {
            this.error = true;
            this.errorMessage = res["errorMessage"];
            this.dataLoading = false;
        }
    },
        (error) => {
            this.error = true;
            this.errorMessage = error.message;
            this.dataLoading = false;
        },
        () => {
            this.dataLoading = false;
        });
    }
 */
  removeLocalStorage() {
    this.id_paciente = window.localStorage.removeItem('idPaciente');
    this.id_section1 = window.localStorage.removeItem('idENCS');
  }


  sleep (time) {
    return new Promise((resolve) => setTimeout(resolve, time));
  }


  imprimir() {
    window.print();
}

findIDCiudadano(id) {

this.showHistorial = true;

}

ngOnDestroy(): void {
this.removeLocalStorage();
}















  /*getCitizenById(id) {
    this.dataLoading = true;

    this.querySubscription = this.backendService.getCiudadanoById(id).subscribe((res) => {
      console.log('CiudadanoById ' + id + ' response');
      console.log(res);
      if (res['errorCode'] > 0) {
          this.error = false;
          this.errorMessage = '';
          this.dataLoading = false;
          this.ciudadano = res['data'][0];
          console.log(this.ciudadano);
      } else {
          this.error = true;
          this.errorMessage = res['errorMessage'];
          this.dataLoading = false;
      }
    },
      (error) => {
        if (error.status === 401 || error.status === 403) {
          localStorage.setItem('token', '');
          this.router.navigate(['/login']);
      }
          this.error = true;
          this.errorMessage = error.message;
          this.dataLoading = false;
      },
      () => {
          this.dataLoading = false;
      });
    }

    getSection1() {
      this.dataLoading = true;

      this.querySubscription = this.backendService.getSection1().subscribe((res) => {
        console.log('Section1 response');
        console.log(res);
        if (res['errorCode'] > 0) {
            this.error = false;
            this.errorMessage = '';
            this.dataLoading = false;
            const resources = res['data'];
            console.log(resources);
            console.log('Looking for ' + this.id_section1 + ' of ' + this.id_paciente);
            resources.forEach(element => {
              if (this.id_section1 === element.id) {
                console.log(element);
                this.section1 = element;
              }
            });
            console.log(this.section1);
        } else {
            this.error = true;
            this.errorMessage = res['errorMessage'];
            this.dataLoading = false;
        }
      },
        (error) => {
          if (error.status === 401 || error.status === 403) {
            localStorage.setItem('token', '');
            this.router.navigate(['/login']);
        }
            this.error = true;
            this.errorMessage = error.message;
            this.dataLoading = false;
            console.log(error);
        },
        () => {
            this.dataLoading = false;
        });
      }

    getSection3() {
      this.dataLoading = true;

      this.querySubscription = this.backendService.getSection3().subscribe((res) => {
        if (res['errorCode'] > 0) {
            this.error = false;
            this.errorMessage = '';
            this.dataLoading = false;
            const resources = res['data'];
            resources.forEach(element => {
              if (this.id_section1 === element.id_section1) {
                this.section3 = element;
              }
            });
            console.log(this.section3);
          } else {
            this.error = true;
            this.errorMessage = res['errorMessage'];
            this.dataLoading = false;
        }
      },
        (error) => {
          if (error.status === 401 || error.status === 403) {
            localStorage.setItem('token', '');
            this.router.navigate(['/login']);
        }
            this.error = true;
            this.errorMessage = error.message;
            this.dataLoading = false;
        },
        () => {
            this.dataLoading = false;
        });
      }


    getSection2() {
      this.dataLoading = true;

      this.querySubscription = this.backendService.getSection2().subscribe((res) => {
        if (res['errorCode'] > 0) {
            this.error = false;
            this.errorMessage = '';
            this.dataLoading = false;
            const resources = res['data'];
            resources.forEach(element => {
              if (this.id_section1 === element.id_section1) {
                this.section2 = element;
              }
            });
            console.log(this.section2);
        } else {
            this.error = true;
            this.errorMessage = res['errorMessage'];
            this.dataLoading = false;
        }
      },
        (error) => {
          if (error.status === 401 || error.status === 403) {
            localStorage.setItem('token', '');
            this.router.navigate(['/login']);
        }
            this.error = true;
            this.errorMessage = error.message;
            this.dataLoading = false;
        },
        () => {
            this.dataLoading = false;
        });
      }

      getSection4() {
        this.dataLoading = true;

        this.querySubscription = this.backendService.getSection4().subscribe((res) => {
          if (res['errorCode'] > 0) {
              this.error = false;
              this.errorMessage = '';
              this.dataLoading = false;
              const resources = res['data'];
              resources.forEach(element => {
                if (this.id_section1 === element.id_section1) {
                  this.section4 = element;
                }
              });
              console.log(this.section4);
            } else {
              this.error = true;
              this.errorMessage = res['errorMessage'];
              this.dataLoading = false;
          }
        },
          (error) => {
            if (error.status === 401 || error.status === 403) {
              localStorage.setItem('token', '');
              this.router.navigate(['/login']);
          }
              this.error = true;
              this.errorMessage = error.message;
              this.dataLoading = false;
          },
          () => {
              this.dataLoading = false;
          });

        }*/



/* chartOptions = {
    responsive: true
  };


  onChartClick(event) {
  }
  myColors = [
    {
      backgroundColor: 'rgba(103, 58, 183, .1)',
      borderColor: 'rgb(103, 58, 183)',
      pointBackgroundColor: 'rgb(103, 58, 183)',
      pointBorderColor: '#fff',
      pointHoverBackgroundColor: '#fff',
      pointHoverBorderColor: 'rgba(103, 58, 183, .8)'
    },
    // ...colors for additional data sets
  ];
 */
}
